import { createContext } from 'react';

const testimonialContext = createContext();

export default testimonialContext;
